module.exports = __webpack_public_path__ + "static/media/01-d-calendar.f0b58a58.png";